<div id="goTo" style="position: relative; overflow-y: scroll">
  <div style="display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: flex-start;">
    @if (intervalReturnMoneyStarting && intervalReturnMoneyEnding) {
      <div style="color: #0F223E !important;
            letter-spacing: -0.34px !important; display: flex; flex-direction: column; width: 100%;">
          <div style="display: flex !important; display: flex; align-items: center !important; justify-content: right !important;
          height:fit-content !important; width:100% !important;"
          (click)="onClose()">
            <img [src]="'assets/icons/crossClose.svg'" style="cursor: pointer;">
          </div>
          <div class="voucher-title bold-16px-center-marine primary-border-100" style="width: 100%; display: flex; align-items: center; justify-content: center; margin: 25px 0px; font-weight: bold !important; text-align: center !important;">
               {{ 'eventDetails.messageReturnMoneyTitle' | translate }}
          </div>
        <div style="padding-left: 24px; padding-bottom: 15px;">
          <ul style="margin: 0;"><li>{{ 'eventDetails.messageReturnMoney1' | translate }} {{intervalReturnMoneyStarting}} {{ 'eventDetails.messageReturnMoney2' | translate }} {{intervalReturnMoneyEnding}} {{ 'eventDetails.hours' | translate}}.</li></ul>
        </div>
        <div style="padding-bottom: 15px; padding-left: 24px;">
          <ul style="margin: 0;"><li>{{ 'eventDetails.messageReturnMoney3a' | translate }} {{intervalReturnMoneySend}} {{ 'eventDetails.messageReturnMoney3b' | translate }}</li></ul>
        </div>
        <div style="padding-bottom: 15px; padding-left: 24px;">
          <ul style="margin: 0;"><li>{{ 'eventDetails.message2' | translate }}</li></ul>
        </div>
        @if (returnMoneyCommission) {
          @if (event.id !== '2cf875a5-d8fd-4963-9501-387bf7664dcd') {
          <div style="padding-bottom: 25px; padding-left: 24px;">
            <ul style="margin: 0;"><li>{{ 'eventDetails.messageReturnMoney4' | translate }} {{returnMoneyCommission}}.</li></ul>
          </div>
          }
          @if (event.id === '2cf875a5-d8fd-4963-9501-387bf7664dcd') {
            <div style="padding-bottom: 25px; padding-left: 24px;">
              <ul style="margin: 0;"><li>{{ 'eventDetails.messageReturnMoneyViveLinares' | translate }}</li></ul>
            </div>
          }
        }
        <div style="text-align: center; padding-bottom: 10px;">
          {{ 'eventDetails.contact' | translate }} <a href="mailto:soporte@bracelit.es" style="font-weight: bold; color: #0F223E; text-decoration: none;">soporte&#64;bracelit.es</a>
        </div>
      </div>
    }
  </div>
</div>
